module.exports = __webpack_public_path__ + "static/media/everyday_digital_cropped.60162548.png";